module.exports = __webpack_public_path__ + "static/media/passenger_bus.5bca13d8.svg";